import { render } from "./AccountSettingModal.vue?vue&type=template&id=6e32e484&ts=true"
import script from "./AccountSettingModal.vue?vue&type=script&lang=ts"
export * from "./AccountSettingModal.vue?vue&type=script&lang=ts"

import "../../node_modules/@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AccountSettingModal.vue?vue&type=style&index=1&id=6e32e484&lang=scss"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__